import React, { Component } from "react";
// import { createPortal } from "react-dom";

const modalStyle = {
  //backgroundColor: "rgba(0,0,0,.2)",
};
export default class ModalTemp extends Component {
  render() {
    return (
      <div style={modalStyle} onClick={this.props.onClick}>
        
        {this.props.children}
      </div>
    )
  }
}
